import { useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import TableLoader from "../../../../common/tableLoader";
import apiCall from "../../../../../apicall";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { loadScript } from "../../../../../globals/constants";
import ReactSlider from "react-slider";

function SectionRecordsFilter({
  _config,
  rowPerPage,
  handleRecordsPerPageChange,
  setTableFilter,
  tableFilter,
  setCurrentPage,
  handleSearchClick,
  handleSearchKeyFunction,
  handleCompanyNameClick,
  handleCompanyNameFunction,
  setPaymentCurrentPage,
  setSearchKey,
  searchKey,
  companyName,
  setCompanyName,
  currentPage,
  displayTimeLogErrErrMsg,
  activeReportTabs,
  jobDetailsInfo,
  positionDropdownList,
  isSameInstitutionJob,
  isAdminRole
}) {
  console.log("activeReportTabsactiveReportTabs",activeReportTabs)
  const {  canActiveTab, role_type, userInfo, TOKEN } = useSelector((state) => state.menu);

  const location = useLocation();
  const currentPathName = location.pathname;
  const professionDropdownRef = useRef(null);
  const statusdropdownRef = useRef(null);
  const workerTypedropdownRef = useRef(null);
  const [professionDropdownOpen, setProfessionDropdownOpen] = useState(false);
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [workerTypeDropdownOpen, setWorkerTypeDropdownOpen] = useState(false);
  const [errSuccessMesg, setErrSuccessMsg] = useState({
    message: "",
    status: "error",
  });
  const [jobTypes, setJobTypes] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedWorkerType, setSelectedWorkerType] = useState([]);
  // const jobStatusMapping = {"Cancelled": "eCancelled", "Closed": "eClosed", "Completed": "eCompleted", "Deleted": "eDeleted", "InProgress": "eInProgress", "Open": "eOpen"};
  // const jobStatuses = Object.keys(jobStatusMapping);
  const workerType = ["Employee", "Trusted Worker"];
  const [startDate, setFromDate] = useState(null); // Store date as Date object
  const [endDate, setToDate] = useState(null);
  const [dateFilterType, setDateFilterType] = useState("")
  const [startDateSelected, setFromDateSelected] = useState("");
  const [endDateSelected, setEndDateSelected] = useState("");
  const [jobStatuses, setJobStatuses] = useState({});
  const [jobStatusMapping, setJobStatusMapping] = useState({})
  const recordsPerPageChange = (event) => {
    handleRecordsPerPageChange(event);
  };

  const handleSortingTable = (event) => {
    setTableFilter({
      ...tableFilter,
      sortType: event.target.value,
      sortDirection: event.target.value === "jobTitle" ? "asc" : "desc",
    });
    setCurrentPage(1);
  };

  const handlePaymentSortingChange = (event) =>{
    setTableFilter({
      ...tableFilter,
      sortType: event.target.value,
      sortDirection: tableFilter?.sortDirection,
    });
    setPaymentCurrentPage(1);
  }

  const firstResultIndex = (currentPage - 1) * rowPerPage + 1;
  const lastResultIndex = Math.min(currentPage * rowPerPage, _config.total);
  console.log("first", firstResultIndex, "last", lastResultIndex, "currentPage", currentPage, "rowPerPage", rowPerPage, _config.total)

  const sortDirectionChange = () => {
    if (tableFilter.sortDirection === "desc"){
      setTableFilter({
        ...tableFilter,
        sortDirection:"asc",
      });
    }else{
      setTableFilter({
        ...tableFilter,
        sortDirection:"desc",
      });
    }
  }

  const handleSearchKeyChange = (e) =>{
    if (e?.target?.value.trim() === "") {
      setPaymentCurrentPage(1);
      setSearchKey("")
      setTableFilter({
        ...tableFilter,
        searchKey: ''
      })
    }else{
      setSearchKey(e.target.value)
    }
  }

    const handleSearchCompanyChange = (e) =>{
    if (e?.target?.value.trim() === "") {
      setPaymentCurrentPage(1);
      setCompanyName("")
      setTableFilter({
        ...tableFilter,
        companyName: ''
      })
    }else{
      setCompanyName(e.target.value)
    }
  }


  const clearSearch = () => {
    setPaymentCurrentPage(1);
    setSearchKey("")
    setTableFilter({
      ...tableFilter,
      searchKey: "",
    });
  };

  const clearCompanySearch = () => {
    setPaymentCurrentPage(1);
    setCompanyName("")
    setTableFilter({
      ...tableFilter,
      companyName: "",
    });
  };
  const handleStatusSelection = (e, status) => {

    setSelectedStatuses((prevSelected) => {
      const updatedSelected = e.target.checked
        ? [...prevSelected, status]
        : prevSelected.includes(status) ? prevSelected.filter((s) => s !== status) : [...prevSelected, status];

      const apiStatuses = updatedSelected.map((status) => jobStatusMapping[status]);
      console.log("apiStatuses====", apiStatuses)
      setTableFilter((prevFilter) => ({
        ...prevFilter,
        jobStatus: apiStatuses.length === 0 ? "" : apiStatuses,
      }));

      console.log("updatedSelected====", updatedSelected)
      return updatedSelected;
    });
    setCurrentPage(1);
  };
  const handlePositionChange = (e, type) => {
    setSelectedTypes((prevSelected) => {
      const updatedSelected = e.target.checked
        ? [...prevSelected, type]
        : prevSelected.filter((item) => item !== type);

      setTableFilter((prevFilter) => ({
        ...prevFilter,
        categoryType: updatedSelected == "" ? "" : updatedSelected,
      }));

      console.log("updatedSelected====", updatedSelected)
      return updatedSelected;
    });

    setCurrentPage(1);
  };
  // const handleWorkerTypeSelection = (e, status) => {
  
  //   setSelectedWorkerType((prevSelected) => {
  //     // Determine the updated list of selected worker types
  //     const updatedSelected = e.target.checked
  //       ? [...prevSelected, status] // Add to the list if checked
  //       : prevSelected.filter((s) => s !== status); // Remove from the list if unchecked
  
  //     // Update the table filter with the selected worker types
  //     setTableFilter((prevFilter) => ({
  //       ...prevFilter,
  //       workerType: updatedSelected.length === 0 ? "All" : updatedSelected,
  //     }));
  
  //     console.log("updatedSelected====", updatedSelected);
  //     return updatedSelected;
  //   });
  
  //   // Reset the current page when selection changes
  //   setCurrentPage(1);
  // };
  const handleWorkerTypeSelection = (e, status) => {
    const value = e.target.value;
  
    setTableFilter((prevFilter) => ({
      ...prevFilter,
      workerType: value,
    }));
  
    setCurrentPage(1); // Reset pagination if needed
  };
  const toggleStatusDropdown = () => {
    setStatusDropdownOpen((prev) => !prev);
    setProfessionDropdownOpen(false);
    setWorkerTypeDropdownOpen(false);
  };
  const toggleProfessionDropdown = () => {
    setProfessionDropdownOpen((prev) => !prev);
    setStatusDropdownOpen(false);
    setWorkerTypeDropdownOpen(false);
  };
  const toggleWorkerTypeDropdown = () => {
    setWorkerTypeDropdownOpen((prev) => !prev);
    setProfessionDropdownOpen(false);
    setStatusDropdownOpen(false);
  };
  useEffect(() => {
    if (currentPathName?.includes("/reports") && !role_type.includes("ROLE_USER")
    ) {
      const fetchData = async () => {
        // setIsJobTypeLoading(true);
        const positionResponse = await apiCall(
          "config/allJobTypes",
          "GET",
          null,
          TOKEN
        );
        if (positionResponse?.data?.length > 0) {
          const jobTypesData = positionResponse.data.map(
            (item) => item.typeName
          );
          setJobTypes(jobTypesData);
          // setIsJobTypeLoading(false);
        }
        else if (positionResponse?.data?.length === 0) {
          // setIsJobTypeLoading(false);
        }
      };

      fetchData();
    }


  }, []);

  useEffect(() => {
        if(positionDropdownList?.length > 0 && jobDetailsInfo?.jobStatus === 'eOpen'){
           const jobTypesData = positionDropdownList?.map(
            (item) => item?.typeName
          );
       setJobTypes(jobTypesData);
    }
  }, [positionDropdownList, jobDetailsInfo])

  console.log("positionDropdownList====", positionDropdownList)


  const fetchJobStatus = async () => {
        const url = role_type?.includes("ROLE_INSTITUTION_ADMIN") ? "institutions/jobStatus" : "openstaff/jobs/jobStatus";
        const jobStatusResponse = await apiCall(
          url,
          "GET",
          null,
          TOKEN
        );
        if (jobStatusResponse?.data?.Accepted) {
          const sorted = Object.keys(jobStatusResponse?.data)
                        .sort().reduce((obj, key) => {
                        obj[key] = jobStatusResponse?.data[key];
                        return obj;
                      }, {});
          setJobStatusMapping(sorted);
          setJobStatuses(Object.keys(sorted));
        }
      };

  useEffect(() => {
    if (currentPathName?.includes("/reports") && !role_type.includes("ROLE_USER") && activeReportTabs !== "report-time") {
      fetchJobStatus();
    }
  }, []);
  // start Date
  const formatDateForPicker = (date) => {
    return date ? moment(date).toDate() : null;
  };
  const handleDateChange = (date, fieldName) => {
    if (fieldName === "startDate") {
      if (date && endDate && moment(date).isAfter(moment(endDate))) {
        displayTimeLogErrErrMsg("Start Date cannot be after End Date.");
        return;
      }
      setFromDate(date);

      // Format date for API (with timezone information)
      const formattedFromDate = date
        ? moment(date).startOf('day').format("YYYY-MM-DD")
        : "";
      setFromDateSelected(formattedFromDate);

      console.log("formattedFromDate======", formattedFromDate, endDateSelected)
      if(formattedFromDate && endDateSelected){
        setTableFilter({
          ...tableFilter,
          startDate: formattedFromDate,
          endDate: endDateSelected,
          dateFilter: dateFilterType
        });
        setCurrentPage(1);
      }
    } else if (fieldName === "endDate") {
      if (date && startDate && moment(date).isBefore(moment(startDate))) {
        displayTimeLogErrErrMsg("End Date cannot be before Start Date.");
        return;
      }

      setToDate(date);

      // Format date for API (with timezone information)
      const formattedToDate = date
        ? moment(date).endOf('day').format("YYYY-MM-DD")
        : "";

      setEndDateSelected(formattedToDate);
      console.log("formattedFromDate======", formattedToDate, startDateSelected)
      if(formattedToDate && startDateSelected){
          setTableFilter({
            ...tableFilter,
            startDate: startDateSelected,
            endDate: formattedToDate,
            dateFilter: dateFilterType
          });
          setCurrentPage(1);
      }
    }
  };
  const handleDateFilterChange = (e) => {
    const value = e.target.value;
  
    if(value !== 'custom'){
      setDateFilterType(value)
      setTableFilter((prevFilter) => ({
        ...prevFilter,
        dateFilter: value,
        endDate: "",
        startDate: ""
      }));
      setCurrentPage(1);
      setFromDate(null);
      setToDate(null);
      setFromDateSelected(null);
      setEndDateSelected(null);
    }else{
      setDateFilterType(value)
    }
  };

    const ProfessionDropdown = ({
      professionDropdownRef,
      professionDropdownOpen,
      toggleProfessionDropdown,
      selectedTypes,
      jobTypes,
      handlePositionChange,
      inviteStatus
    }) => {
      return (
          <div className="custom-dropdown" ref={professionDropdownRef}>
            <button
              type="button"
              className="btn dropdown-toggle form-control"
              onClick={toggleProfessionDropdown}
              style={{
                color: "black",
                textAlign: "left",
                height: "auto",
                opacity: "0.5",
                overflow: "auto",
                scrollbarWidth: "none",
                fontSize: inviteStatus && "12px" 
              }}
            >
              {selectedTypes?.length > 0
                ? selectedTypes?.join(", ")
                : "Search by profession(s)"}
            </button>

            {professionDropdownOpen && (
              <div className={`dropdown-menu show`}>
                {jobTypes?.map((type) => (
                  <div key={type} className="dropdown-item">
                    <input
                      type="checkbox"
                      style={{ marginRight: 10 }}
                      value={type}
                      checked={selectedTypes.includes(type)}
                      onChange={(e) => handlePositionChange(e, type)}
                    />
                    <label>{type}</label>
                  </div>
                ))}
              </div>
            )}
          </div>
      );
    };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event?.target;
    setTableFilter((prevValues) => ({
      ...prevValues,
      [name]: checked,
    }));
  };

  const handleSliderChange = (value) => {
     setTableFilter((prevValues) => ({
      ...prevValues,
      sliderValue: value,
    }));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (statusdropdownRef?.current && !statusdropdownRef?.current.contains(event.target)) {
        setStatusDropdownOpen(false);
      }
      if (professionDropdownRef?.current && !professionDropdownRef?.current.contains(event.target)) {
        setProfessionDropdownOpen(false);
      }
      if (workerTypedropdownRef?.current && !workerTypedropdownRef?.current.contains(event.target)) {
        setWorkerTypeDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  useEffect(() => {
    loadScript("js/custom.js");
  });

  useEffect(() => {
    if(activeReportTabs){
      setSelectedStatuses([])
      setSelectedTypes([])
      setSearchKey("")
      if(activeReportTabs !== "report-time"){
        setCompanyName("");
      }
      setFromDate(null);
      setToDate(null);
      setFromDateSelected(null);
      setEndDateSelected(null);
      setDateFilterType("")
    }
  }, [activeReportTabs])

  useEffect(() => {
    if(_config?.showAssignInviteEmployeeTrustedWorkerFilter){
      console.log("tableFilter?.categoryType==", tableFilter?.categoryType)
      setSelectedTypes(tableFilter?.categoryType)
    }
  }, [tableFilter])


  return (
    <>
      {_config?.paymentFilter && (
        <div className="container m-b30 payment-history-filter">
          <div className="row">
            {(activeReportTabs === "report-jobs" || activeReportTabs === "report-payment-history") && (
              <>
                <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                  <div>
                    <div className="custom-dropdown" ref={statusdropdownRef}>
                      <button
                        type="button"
                        className="btn dropdown-toggle form-control"
                        onClick={toggleStatusDropdown}
                        style={{ color: "black", textAlign: "left", height: "auto", opacity: "0.5", overflow: 'auto', scrollbarWidth: "none" }}
                      >
                        {selectedStatuses?.length > 0 ? selectedStatuses?.join(", ") : "Status"}
                      </button>
                      {
                        statusDropdownOpen && (
                          <div className={`dropdown-menu show`}>
                            {jobStatuses.map((status) => (
                              <div key={status} className="dropdown-item">
                                <input
                                  type="checkbox"
                                  style={{ marginRight: 10 }}
                                  value={status}
                                  checked={selectedStatuses?.includes(status)}
                                  onChange={(e) => handleStatusSelection(e, status)}
                                />
                                <label>{status}</label>
                              </div>
                            ))}
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                  <div>

                    <div className="custom-dropdown" ref={professionDropdownRef}>
                      <button
                        type="button"
                        className="btn dropdown-toggle form-control"
                        onClick={toggleProfessionDropdown}
                        style={{
                          color: "black",
                          textAlign: "left",
                          height: "auto",
                          opacity: "0.5",
                          overflow: 'auto',
                          scrollbarWidth: "none"
                        }}
                      >
                        {selectedTypes?.length > 0
                          ? selectedTypes?.join(", ")
                          : "Search by profession(s)"}
                      </button>
                      {
                        professionDropdownOpen &&
                        (
                          <div className={`dropdown-menu show`}>
                            {jobTypes?.map((type) => (
                              <div key={type} className="dropdown-item">
                                <input
                                  type="checkbox"
                                  style={{ marginRight: 10 }}
                                  value={type}
                                  checked={selectedTypes.includes(type)}
                                  onChange={(e) => handlePositionChange(e, type)}
                                />
                                <label>{type}</label>
                              </div>
                            ))}
                          </div>
                        )
                      }

                    </div>
                  </div>
                </div> */}
                <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                <ProfessionDropdown
                  professionDropdownRef={professionDropdownRef}
                  professionDropdownOpen={professionDropdownOpen}
                  toggleProfessionDropdown={toggleProfessionDropdown}
                  selectedTypes={selectedTypes}
                  jobTypes={jobTypes}
                  handlePositionChange={handlePositionChange}
                />
                </div>
              </>
            )}
            
            {!(activeReportTabs === "report-jobs" || activeReportTabs === "report-payment-history") && !(role_type?.includes("ROLE_OPENSTAFF_ADMIN") || role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && 
            (
            <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
              <select
                    className="wt-select-bar-large selectpicker"
                    data-live-search="true"
                    data-bv-field="size"
                    value={tableFilter?.workerType || ""}
                    onChange={handleWorkerTypeSelection}
                  >
                    <option value="All">Select Worker Type</option>
                    <option value="Employee">Employee</option>
                    <option value="Trusted Worker">Trusted Worker</option>
                  </select>
            </div>
            )}
            {/* {activeReportTabs != "report-payment-history" && (
              <> */}
              {
                (role_type?.includes("ROLE_OPENSTAFF_ADMIN") || role_type?.includes("ROLE_OPENSTAFF_FINANCIAL_ADMIN")) && currentPathName?.includes('/reports') &&
                  <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                  <div className="input-group">
                      <input
                        type="text"
                        placeholder={`Search by Company Name`}
                        id='payment-companykey'
                        value={companyName}
                        onChange={(e) => handleSearchCompanyChange(e)}
                        onKeyPress={handleCompanyNameClick}
                      />
                        {companyName && (
                      <button
                        type="button"
                        className="btn"
                        id='clear-company-name'
                        onClick={clearCompanySearch}
                      >
                        <i className="fas fa-times" />
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn"
                      style={{
                        position: 'absolute',
                        right: '-15px',
                        top: 13,
                        zIndex: 2,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                    >
                      <i className="feather-search" onClick={handleCompanyNameFunction} />
                    </button>
                  </div>
                </div>
              }
                {
                  currentPathName?.includes('/reports') && 
                  <div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                    <select
                      className="wt-select-bar-large selectpicker"
                      data-live-search="true"
                      data-bv-field="size"
                      value={tableFilter?.dateFilter || ""}
                      onChange={handleDateFilterChange}
                    >
                      <option value="">Select Date Range</option>
                      <option value="pastweek">Past Week</option>
                      <option value="past30Days">Past 30 Days</option>
                      <option value="previousMonth">Previous Month</option>
                      <option value="pastYear">Past Year</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>
                }

                {dateFilterType === "custom" && (<div className="col-xl-2 col-lg-2 col-md-12 mb-4 d-flex">
                  <div className="col-xl-10 col-lg-10 col-md-10 mb-4 input-group">
                    <ReactDatePicker
                      className="form-control start-date"
                      selected={formatDateForPicker(startDate)}
                      onChange={(date) => handleDateChange(date, "startDate")}
                      dateFormat="MM-dd-yyyy"
                      placeholderText="MM/DD/YYYY"
                      disabled={dateFilterType !== "custom"}
                    />
                  </div>
                  <div className="col-xl-2 col-lg-2 col-md-2 mb-4">
                    <span className="sort-icon">
                      <i className="fas fa-minus" style={{ marginLeft: "5px", marginTop: "20px" }} />
                    </span>
                  </div>
                </div>
                )}
                {dateFilterType === "custom" && (<div className="col-xl-2 col-lg-2 col-md-12 mb-4">
                  <div className="input-group">
                    <ReactDatePicker
                      className="form-control end-date"
                      selected={formatDateForPicker(endDate)}
                      onChange={(date) => handleDateChange(date, "endDate")}
                      dateFormat="MM-dd-yyyy"
                      placeholderText="MM/DD/YYYY"
                      disabled={dateFilterType !== "custom"}
                    />
                  </div>
                </div>
                )}
              {/* </>
            )} */}

          </div>
        </div>
      )}
     {
        _config?.showAssignInviteEmployeeTrustedWorkerFilter && (
          <div className="row align-items-center">
            {(isSameInstitutionJob || isAdminRole)  && (
              <>
                <div className="col-xl-3 col-lg-3 col-md-3">
                  <label className="custom-checkbox fs-6">
                    <input
                      type="checkbox"
                      name="employeesOnly"
                      checked={tableFilter?.employeesOnly}
                      onChange={handleCheckboxChange}
                      disabled={role_type?.includes("ROLE_INSTITUTION_ADMIN") && (!jobDetailsInfo?.isEmployeeOnly || !jobDetailsInfo?.isTrustedWorkerOnly)}
                    />
                    <span className="custom-checkbox-label ml-3">Employee</span>
                  </label>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3">
                  <label className="custom-checkbox fs-6">
                    <input
                      type="checkbox"
                      name="trustedWorkersOnly"
                      checked={tableFilter?.trustedWorkersOnly}
                      onChange={handleCheckboxChange}
                      disabled={role_type?.includes("ROLE_INSTITUTION_ADMIN") && (!jobDetailsInfo?.isEmployeeOnly || !jobDetailsInfo?.isTrustedWorkerOnly)}
                    />
                    <span className="custom-checkbox-label ml-3">
                      Trusted Worker
                    </span>
                  </label>
                </div>
                {!role_type?.includes("ROLE_INSTITUTION_ADMIN") && (
                  <>
                    <div className="col-xl-3 col-lg-3 col-md-3">
                      <label className="custom-checkbox fs-6">
                        <input
                          type="checkbox"
                          name="other"
                          checked={tableFilter?.other}
                          onChange={handleCheckboxChange}
                        />
                        <span className="custom-checkbox-label ml-3">
                          Other
                        </span>
                      </label>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-3 fs-6">
                      <ProfessionDropdown
                        professionDropdownRef={professionDropdownRef}
                        professionDropdownOpen={professionDropdownOpen}
                        toggleProfessionDropdown={toggleProfessionDropdown}
                        selectedTypes={selectedTypes}
                        jobTypes={jobTypes}
                        handlePositionChange={handlePositionChange}
                        inviteStatus={true}
                      />
                    </div>
                  </>
                )}
              </>
            )}

            <div className="slider-container mt-2 mb-5">
              <ReactSlider
                ariaLabelledby="slider-label"
                className="horizontal-slider"
                name="distance"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                value={tableFilter?.sliderValue}
                onAfterChange={handleSliderChange}
                min={0}
                max={100}
                renderThumb={(props, state) => (
                  <div {...props}>{state?.valueNow}</div>
                )}
              />
              <div className="slider-input">
                <input
                  class="form-control"
                  type="text"
                  disabled=""
                  value={tableFilter?.sliderValue}
                />
              </div>
            </div>
          </div>
        )
      }
      <div className="product-filter-wrap d-flex justify-content-between align-items-center m-b30">
        <span className="woocommerce-result-count-left">
          {/* {_config.prefix}
          {_config.showRange ? " 1-" + _config.showingUpto + " of " : " "}
          {_config.total + " " + _config.type} */}
          {_config.prefix}{" "} 
          {_config.total > 0
            ? `${firstResultIndex}-${lastResultIndex} of ${_config.total}` 
            : `${_config.total}`}{" "}
            {_config.type}
        </span>
        <form className="woocommerce-ordering twm-filter-select sortbyfilterselect" method="get">
          {/* {_config?.type !== "Records" && ( */}
          {_config?.isSorting && (
            <>
              <span className="woocommerce-result-count">Sort By</span>
              <select
                className="wt-select-bar-2 selectpicker"
                data-live-search="true"
                data-bv-field="size"
                value={tableFilter?.sortType}
                onChange={handleSortingTable}
              >
                {!(currentPathName?.includes("/can-list") ||
                  currentPathName?.includes("/can-grid") ||
                  currentPathName?.includes("/users-list") ||
                  currentPathName?.includes("/users-grid") ||
                  currentPathName?.includes("/comp-list") ||
                  currentPathName?.includes("/comp-grid") ||
                  currentPathName?.includes("/candidate/my-teams")) && (
                    <>
                      <option value="recentJobs">Most Recent</option>
                    </>
                  )}
                {/* <option value="createdDate">Distance</option> */}
                {(currentPathName?.includes("/job-list") ||
                  currentPathName?.includes("/job-grid") ||
                  currentPathName?.includes("/search-job") ||
                  currentPathName?.includes("/applied-job") ||
                  currentPathName?.includes("/ongoing-job") ||
                  currentPathName?.includes("/schedule-job") ||
                  currentPathName?.includes("/comp-detail") ||
                  currentPathName?.includes("/history-job")) && (
                    <>
                      <option value="salary">Salary</option>
                      <option value="startDate">Recent Job Start</option>
                    </>
                  )}
                
                {(currentPathName?.includes("/can-list") ||
                  currentPathName?.includes("/can-grid") ||
                  currentPathName?.includes("/users-list") ||
                  currentPathName?.includes("/users-grid") ||
                  currentPathName?.includes("/comp-list") ||
                  currentPathName?.includes("/comp-grid")) && (
                    <>
                      <option value="recent">Recent</option>
                    </>
                  )}
                {(currentPathName?.includes("/comp-list") ||
                  currentPathName?.includes("/comp-grid")) && (
                    <>
                      <option value="rating">Rating</option>
                    </>
                )}
                {(currentPathName?.includes("/can-list") ||
                  currentPathName?.includes("/can-grid") ||
                  currentPathName?.includes("/users-list") ||
                  currentPathName?.includes("/users-grid") ||
                  currentPathName?.includes("/comp-list") ||
                  currentPathName?.includes("/comp-grid") ||
                  currentPathName?.includes("/candidate/my-teams")) && (
                    <>
                      <option value="name">Name</option>
                    </>
                  )}
                {(currentPathName?.includes("/comp-list") ||
                  currentPathName?.includes("/comp-grid") ||
                  currentPathName?.includes("/can-list") ||
                  currentPathName?.includes("/can-grid")) && (
                    <>
                      <option value="distance">Distance</option>
                    </>
                  )}
              </select>
              <span className="sort-icon" onClick={sortDirectionChange}>
                <i className={`fas ${tableFilter.sortDirection === 'asc' ? 'fa-sort-amount-up-alt' : 'fa-sort-amount-down'}`} style={{marginRight: "20px", marginLeft: "20px", fontSize: "24px", cursor: "pointer"}}/>
              </span>
            </>
          )}
          {console.log("canActiveTab----",canActiveTab)}
          {_config?.paymentFilter && (
            <>
            {/* <h4 className="section-head-small mb-4">Status</h4> */}
            <select
              className="wt-select-bar-large selectpicker"
              data-live-search="true"
              data-bv-field="size"
              value={tableFilter?.sortType || ""}
              onChange={handlePaymentSortingChange}
            >
              <option value="createdDate">Most Recent</option>
              {
               activeReportTabs === "report-payment-history" && 
               <option value="jobTitle">Job Title</option>
              }
              
              {
                role_type.includes('ROLE_OPENSTAFF_ADMIN') && 
                <option value="name">Company</option>
              }
             
                {!(activeReportTabs === "report-jobs" || activeReportTabs === "report-time") && (
                  <>
                    <option value="amount">Amount</option>
                    <option value="serviceFee">Service Fee</option>
                    <option value="paymentMethod">Payment Method</option>
                  </>)}
               {
               activeReportTabs === "report-payment-history"  && 
               <option value="jobStatus">Status</option>
              }
             
            </select>
            <span className="sort-icon" onClick={sortDirectionChange}>
                <i className={`fas ${tableFilter.sortDirection === 'asc' ? 'fa-sort-amount-up-alt' : 'fa-sort-amount-down'}`} style={{marginRight: "20px", marginLeft: "20px", fontSize: "24px"}}/>
              </span>
          </>
          )
          }
          {_config?.paymentFilter && (
          <div className="input-group">
                <input
                  type="text"
                  // className="form-control"
                  style={{marginRight: 10}}
                  placeholder={`Search by ${activeReportTabs === 'report-time' ? 'Name' : 'Job title'}`}
                  id='payment-searchkey'
                  value={searchKey}
                  onChange={(e) => handleSearchKeyChange(e)}
                  onKeyPress={handleSearchClick}
                />
                  {searchKey && (
                <button
                  type="button"
                  className="btn"
                  onClick={clearSearch}
                  style={{
                    position: 'absolute',
                    right: '40px',
                    top: 8,
                    zIndex: 2,
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  <i className="fas fa-times" />
                </button>
              )}
              <button
                type="button"
                className="btn"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: 8,
                  zIndex: 2,
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                }}
              >
                <i className="feather-search" onClick={handleSearchKeyFunction} />
              </button>
            </div>
          )}
          
          <select
            className="wt-select-bar-2 selectpicker"
            data-live-search="true"
            data-bv-field="size"
            value={rowPerPage}
            onChange={recordsPerPageChange}
          >
            <option value={10}>Show 10</option>
            <option value={20}>Show 20</option>
            <option value={50}>Show 50</option>
          </select>
        </form>
      </div>
    </>
  );
}

export default SectionRecordsFilter;
